export const ATTACHMENT_PLUGIN_KEY = 'attachment';
export const ATTACHMENT_TYPE = 'attachment';
